import styled from "styled-components"

import Modal, {ModalInner} from "@irati/ui/src/Modal"

export const StyledModal = styled(Modal)`
  ${ModalInner} {
    padding: 0;
  }
`

export const ModalContent = styled.div`
  padding: 15px;
`

export const StyledHeader = styled.div`
  border-bottom: 1px solid ${({theme}) => theme.colors.greys.light};
  display: flex;
  padding: 15px;
`

export const StyledFooter = styled.div`
  border-top: 1px solid ${({theme}) => theme.colors.greys.light};
  padding: 15px;
  text-align: right;
`
